export default function () {
  return function (object, value) {
    return object || value
  }
}
